import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { WarehouseLocation } from '../../models/warehouse-location.model';
import { WarehouseLocationService } from '../../services/warehouse-location.service';

@Component({
    selector: 'app-locations-label',
    templateUrl: './locations-label.component.html',
    styleUrls: ['./locations-label.component.scss'],
    standalone: false
})
export class LocationsLabelComponent implements OnInit {

  warehouseLocation: WarehouseLocation = new WarehouseLocation();

  isServerError: boolean = false;

  constructor(private route: ActivatedRoute,
    private warehouseLocationService: WarehouseLocationService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadWarehouseLocation(+params['id']);
    })
  }

  loadWarehouseLocation(id: number): void {
    this.warehouseLocationService.getWarehouseLocationById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      this.isServerError = true;
      return e;
    }))
    .subscribe((warehouseLocation: WarehouseLocation) => {
      this.warehouseLocation = warehouseLocation;
    })
  }

  getShelf(): string {
    return this.warehouseLocation.aisle + ' / ' + this.warehouseLocation.shelf;
  }

  getWarehouseName(): string {
    return this.warehouseLocation.warehouse ? this.warehouseLocation.warehouse.name : '';
  }

  print(): void {
    window.print();
  }
}
